export default function () {
    var price = $('.price-for-free-shipping')

    if (price.length <= 0) {
        return;
    }

    $.ajax({
        url: '/umbraco/Surface/Basket/GetFreeShippingLabel',
        type: 'GET',
        success: function (data) {
            if (!data) {
                price.hide();
                return;
            }

            price.html(data);
            price.show();
        }
    });
}